export const COMPOUND_OPERATOR_AND = 'and';
export const COMPOUND_OPERATOR_OR = 'or';
